export const GET_SO_CART_PAGING_START = 'GET_SO_CART_PAGING_START';

export const GET_SO_CART_PAGING_SUCCESS = 'GET_SO_CART_PAGING_SUCCESS';

export const GET_SO_CART_PAGING_FAILURE = 'GET_SO_CART_PAGING_FAILURE';
